import { createSlice } from '@reduxjs/toolkit';
// utils
import { axiosInstance as axios } from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  filter: {
    business: null,
    menu: null,
  },
  dashboard: null,
  report: [],
  data: [],
  meta: null,
  params: {
    page: 1,
    active: true,
    deleted: false,
    type: 'sale',
    state: 'draft',
  },
  record: null,
};

const slice = createSlice({
  name: 'explore',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
      state.record = null;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // Load Dashboard
    loadDashboardSuccess(state, action) {
      state.isLoading = false;
      state.dashboard = action.payload;
    },

    // GET REPORT
    getReportSuccess(state, action) {
      state.isLoading = false;
      state.report = action.payload;
      state.error = false;
    },

    // GET RecordS
    getRecordsSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload.results;
      state.meta = action.payload.meta;
      state.error = false;
    },

    // GET Record
    getRecordSuccess(state, action) {
      state.isLoading = false;
      state.record = action.payload;
      state.error = false;
    },

    // SET PARAMS
    setParams(state, action) {
      state.params = action.payload;
    },

    // SET Business
    setBusiness(state, action) {
      state.filter.business = action.payload;
    },

    // SET Menu
    setMenu(state, action) {
      state.filter.menu = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { setParams, setBusiness, setMenu } = slice.actions;

// ----------------------------------------------------------------------

export function getDashboard(params) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/explore/dashboard', {
        params,
      });
      dispatch(slice.actions.loadDashboardSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

// ----------------------------------------------------------------------

export function getReport(url, params = {}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/explore/${url}`, {
        params,
      });
      dispatch(slice.actions.getReportSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getRecords(params = {}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      if (params?.business_id && params?.model) {
        const response = await axios.get('/explore/record/', {
          params,
        });
        dispatch(slice.actions.getRecordsSuccess(response.data));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getRecord(id, params = {}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/explore/record/${id}/`, {
        params,
      });
      dispatch(slice.actions.getRecordSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
